'use client';

import { useState, useCallback } from 'react';

import LoginModal from '@/components/auth/loginModal';
import { useAuth } from '@/providers/userContext';
import { setPostLoginRedirect } from '@/lib/client/postLoginRedirect';
import { logout as logoutAction } from '@/lib/client/sessionActions';
import LogoutModal from '@/components/auth/logoutModal';

export default function FooterLoginLink({ className = '', children = 'Login' }) {
  const { user } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleLogout = useCallback(async () => {
    try {
      await logoutAction();
      setShowLogoutModal(false);
    } catch (err) {
      console.error('Logout failed:', err);
    }
  }, []);

  const handleClick = useCallback(() => {
    if (user) {
      setShowLogoutModal(true);
      return;
    }

    if (typeof window !== 'undefined') {
      setPostLoginRedirect(window.location.href);
    }
    setShowLoginModal(true);
  }, [user]);

  const baseClassName = 'block text-base text-white transition';
  const combinedClassName = className ? `${baseClassName} ${className}` : baseClassName;

  return (
    <>
      <button type="button" className={combinedClassName} onClick={handleClick}>
        {user ? 'Logout' : children}
      </button>
      {showLoginModal && <LoginModal onClose={() => setShowLoginModal(false)} />}
      {showLogoutModal && (
        <LogoutModal
          isOpen={showLogoutModal}
          onConfirm={handleLogout}
          onCancel={() => setShowLogoutModal(false)}
        />
      )}
    </>
  );
}
